import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Identifier, Order } from "risa-data-model";
import { FirestoreService } from "../../../shared/api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../shared/api/firebase/references";
import { AppDispatch } from "../store/store";

interface OrdersForPatient {
  data?: Order[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: OrdersForPatient = {
  data: null,
  loading: false,
  error: null,
};

const ordersForPatientSlice = createSlice({
  name: "ordersForPatient",
  initialState,
  reducers: {
    fetchOrderStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchOrderSuccess(state, action: PayloadAction<Order[]>) {
      state.data = action.payload;
      state.loading = false;
    },
    fetchOrderFailure(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.loading = false;
    },
    resetOrder(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchOrderStart,
  fetchOrderSuccess,
  fetchOrderFailure,
  resetOrder,
} = ordersForPatientSlice.actions;

const isIdentifierPresent = (
  identifier: string,
  identifiers?: Identifier[],
): boolean => {
  return identifiers?.some((item) => item.ID === identifier) || false;
};

export const fetchOrdersFromFirebaseForPatientWithId =
  (id?: string) => async (dispatch: AppDispatch) => {
    dispatch(fetchOrderStart());
    try {
      const unsubscribe = FirestoreService.listenToAllDocuments<Order>(
        FirestoreCollectionReference.orders(),
        (orders) => {
          const filteredOrders = orders.filter((order) => {
            if (
              isIdentifierPresent(id ? id : "", order?.Patient?.Identifiers)
            ) {
              return order;
            } else {
              return null;
            }
          });

          dispatch(fetchOrderSuccess(filteredOrders));
        },
        (error) => {
          dispatch(fetchOrderFailure(error.message));
        },
      );

      return unsubscribe;
    } catch (error: any) {
      dispatch(fetchOrderFailure(error.message));
    }
  };

export default ordersForPatientSlice.reducer;
